import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-badge p-component'
};
var BadgeDirectiveStyle = BaseStyle.extend({
  name: 'badge-directive',
  classes: classes
});

export { BadgeDirectiveStyle as default };
//# sourceMappingURL=index.mjs.map
